// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ReopenEmployeeAdvanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_ReopenEmployeeAdvanceResponseDados {
id: number
status: number
status_label: string
}

export type Payroll_ReopenEmployeeAdvanceResponse = ApiResponse<Payroll_ReopenEmployeeAdvanceResponseDados>;

registerResponseContract('Payroll_ReopenEmployeeAdvanceResponse', {
  id:           { type: 'number',  required: true },
  status:       { type: 'number',  required: true },
  status_label: { type: 'string',  required: true },
})
